import * as Globals from "../../globals";
import {HBESectionWidth, HBEWallDefaultThickness} from "../../globals";
import {Box3, BoxGeometry, Euler, Group, Mesh, Quaternion, Vector3,MeshBasicMaterial,SphereGeometry} from "three";
import {
    addEdgeGeometry,
    createGroup,
    cutMeshToSize,
    findChildByName,
    findChildrenByName,
    getLengthByAxis
} from "../../utils/threeUtils";
import {storeBufferGeometry} from "../../utils/modelLoader";
import {pad, sortBySubKey, toFixedFloat} from "../../utils/utils";
import {setObjectLayer} from "../../utils/layerUtils";
import {buildingGroup, standardWallChosen, wallMeshHBE, wallMeshHBE_L} from "../../main";
import {wallDirection} from "./wallGeneration";
import * as SceneManager from "../../sceneManager";
import {clearGroup} from "../../sceneManager";
import {CSG} from "three-csg-ts";
import {createRooms} from "../rooms/roomGeneration";
import {getVolume} from "../../utils/volumeUtils";
import {Raehm} from "./raehm";
import {Schwelle} from "./schwelle";
import * as nameConstants from "../../constants/nameConstants";
import {controlObjectName, cutOutsGroupName, supportBeamMeshName} from "../../constants/nameConstants";
import {boundingBoxMaterial, cutWallMaterial, outerWallMaterial, wallMaterial} from "../../constants/materialConstants";
import {wallMeshKeyWidth} from "../../constants/wallConstants";
import {cutOutTypes, getCutOutTypeFromString} from "../cutOuts/cutOutGeneration";
import {areOverlapping} from "../../utils/mathUtils";
import * as interiorDoorConstants from "../../constants/cutOuts/interiorDoorConstants";
import {CutOut} from "../cutOuts/cutOut";
import {showMessage} from "../../../ui/ui";
import {t} from "../../../i18n";

export class Wall {
    //A wall is a group of segments (Threejs Group type)
    constructor(wallPreview, direction, length, isOuterWall, placeWall = true) {
        this.wallPreview = wallPreview;
        //Anpassung Rotation nach #12766: Wände laufen nur noch in positive X und Z > Nut im links oder oben
        this.direction = (direction === wallDirection.positiveZ || direction === wallDirection.negativeZ) ? wallDirection.positiveZ : wallDirection.positiveX;
        this.height = Globals.defaultWallHeight;
        this.isOuterWall = isOuterWall;
        this.placeWall = placeWall;

        let bounds = new Box3().setFromObject(this.wallPreview);
        let size = bounds.getSize(new Vector3());
        this.length = length;
        let position = bounds.getCenter(new Vector3());

        this.wall = createWallSegment(this.length, this.height, standardWallChosen ? wallMeshHBE_L : wallMeshHBE, Globals.layers.wall, true, true, this.direction, this.isOuterWall, this.placeWall); //Create a wall segment with calculated size

        //Rotation der Wand: Stehend + Ausrichtung nach Vorschau
        this.wall.rotateX(Math.PI / 2); //Rotate wall to be upright

        //Positive X ist die default Rotation nach dem Aufstellen der Wand entsprechend keine weitere Rotation notwendig.
        //Rotation in Positive Z Richtung
        if (this.direction === wallDirection.positiveZ || this.direction === wallDirection.negativeZ) {
            this.wall.rotation.z = Math.PI / 2;
        }

        //Grundpositionierung
        this.wall.position.copy(position);
        this.wall.position.setY((this.height / 2) - Globals.defaultSchwelleHeight + 0.01);

        //Offset addieren, da Wände mit kleinem Offset in z-Richtung angelegt werden. TODO: Sollte in Zukunft rausgerechnet werden am besten bei Erstellung schon?
        let wallCenter = new Box3().setFromObject(this.wall).getCenter(new Vector3());
        let offset = new Vector3().subVectors(position, wallCenter);
        this.wall.position.x += offset.x;
        this.wall.position.z += offset.z;

        
        
       // this.createResizeHandles();
       // this.setupSelectInteraction();

        restoreWallLayers(this.wall);
        this.wall.name = nameConstants.wallGroupName;
        this.wall.userData.isOuterWall = this.isOuterWall; //Außenwandattribut festlegen
        return this.wall;
    }

    /* setupSelectInteraction() {
        console.log("setupSelectInteraction",this.object);
        this.wall.userData.onSelect = () =>{};// this.showHandles();
        this.wall.userData.onDeselect = () =>{};// this.hideHandles();
        this.wall.userData.OnResizeWall = (handle, newPosition) =>{};// this.resizeWall(handle, newPosition);
    } */

    createResizeHandles() {
        const handleGeometry = new BoxGeometry(0.25, 0.25, 0.25);
        const handleMaterial = new MeshBasicMaterial({ color: 0x256597 });

        this.startHandle = new Mesh(handleGeometry, handleMaterial);
        this.endHandle = new Mesh(handleGeometry, handleMaterial);
        this.startHandle.name = "startHandle";
        this.endHandle.name = "endHandle";
        this.updateHandlePositions();

        this.startHandle.visible = false;
        this.endHandle.visible = false;

        this.wall.add(this.startHandle);
        this.wall.add(this.endHandle);
    }

    updateHandlePositions() {
        const wallBounds = new Box3().setFromObject(this.wall);
        const wallSize = wallBounds.getSize(new Vector3());
        console.log(wallSize);
        if (this.direction === wallDirection.positiveX || this.direction === wallDirection.negativeX) {
            this.startHandle.position.set(-wallSize.x / 2 - 0.1, wallSize.z/2,-wallSize.y / 2);
            this.endHandle.position.set(wallSize.x / 2 + 0.1, wallSize.z/2, -wallSize.y / 2);
        } else {
            this.startHandle.position.set(wallSize.z/2 + 0.1, wallSize.x/2, -wallSize.y / 2);
            this.endHandle.position.set(-wallSize.z/2 - 0.1, wallSize.x/2, -wallSize.y / 2);
        }
    }

    getClickedHandle(position) {
        const raycaster = new THREE.Raycaster();
        const mouse = new THREE.Vector2();

        // Convert screen coordinates to normalized device coordinates
        mouse.x = (position.x / window.innerWidth) * 2 - 1;
        mouse.y = -(position.y / window.innerHeight) * 2 + 1;

        raycaster.setFromCamera(mouse, SceneManager.layoutCamera);

        const intersects = raycaster.intersectObjects([this.startHandle, this.endHandle]);

        if (intersects.length > 0) {
            return { handle: intersects[0].object, isStart: intersects[0].object === this.startHandle };
        }

        return null;
    }

    resizeWall(handle, newPosition) {
        const wallBounds = new Box3().setFromObject(this.wall);
        const wallSize = wallBounds.getSize(new Vector3());
        let newLength;

        if (this.direction === wallDirection.positiveX || this.direction === wallDirection.negativeX) {
            newLength = Math.abs(newPosition.x - this.wall.position.x) * 2;
        } else {
            newLength = Math.abs(newPosition.z - this.wall.position.z) * 2;
        }

        // Round the new length to the nearest HBESectionWidth
        newLength = Math.round(newLength / HBESectionWidth) * HBESectionWidth;

        // Ensure the wall is at least one section wide
        newLength = Math.max(newLength, HBESectionWidth);

         if (newLength !== this.length) {
            this.length = newLength;
            this.updateWallGeometry();
            //this.updateHandlePositions();
        }
    }

    updateWallGeometry() {
        // Remove existing wall segment
        this.wall.remove(...this.wall.children);

        // Create new wall segment with updated length
        const newWallSegment = createWallSegment(this.length, this.height, standardWallChosen ? wallMeshHBE_L : wallMeshHBE, Globals.layers.wall, true, true, this.direction, this.isOuterWall, this.placeWall);

        // Copy properties from the old wall to the new one
        newWallSegment.position.copy(this.wall.position);
        newWallSegment.rotation.copy(this.wall.rotation);
        newWallSegment.scale.copy(this.wall.scale);

        // Replace the old wall with the new one
        const parent = this.wall.parent;
        parent.remove(this.wall);
        parent.add(newWallSegment);
        this.wall = newWallSegment;
        
        restoreWallLayers(this.wall);
        this.wall.name = nameConstants.wallGroupName;
        this.wall.userData.isOuterWall = this.isOuterWall;
        // Recreate resize handles
        this.createResizeHandles();
        this.setupSelectInteraction();
        //this.updateHandlePositions();
        this.showHandles();
        // Update related elements (e.g., rooms, measurements)
        createRooms();
        //restoreWallLayers(this.wall);
        // Call other necessary update functions here
    }
    
    showHandles() {
        this.startHandle.visible = true;
        this.endHandle.visible = true;
    }

    hideHandles() {
        this.startHandle.visible = false;
        this.endHandle.visible = false;
    }
}



//Allgemeine Wandstückerstellung
export function createWallSegment(width, depth, wallMesh, layer, addRaehmAndSchwelle = true, cutToSize = true, direction = null, isOuterWall = false, placeWall = true) {
    console.log("createWallSegment", width, depth, wallMesh, layer, addRaehmAndSchwelle, cutToSize, direction, isOuterWall, placeWall);
    width = toFixedFloat(width, 5);
    depth = toFixedFloat(depth, 5);

    if (width === 0 || depth === 0) {
        return null;
    }

    let material = isOuterWall ? outerWallMaterial : wallMaterial;
    //TODO: Irgendwo kommt ein offset von -0.01 in Y raus
    let raehmHeight = Globals.defaultRaehmHeight; //Höhe für Berechnungen. Kann angepasst werden, wenn dynamische Höhe nötig
    let schwelleHeight = Globals.defaultSchwelleHeight; //Höhe für Berechnungen. Kann angepasst werden, wenn dynamische Höhe nötig
    let userData = {...wallMesh.userData}; //Gets userData without reference to wallMesh
    let wallGroup = new Group();

    let wallElementHeight = addRaehmAndSchwelle ? depth - schwelleHeight - raehmHeight : depth;

    if (cutToSize) {
        wallMesh = cutMeshToSize(wallMesh, "z", wallElementHeight);
    }

    let count = parseInt(Math.ceil(width / Globals.HBESectionWidth).toString()); //Amount of wall pieces needed to fill given length
    let blockInsertOffset = getLengthByAxis(wallMesh.geometry.boundingBox, "x") - Globals.HBESectionWidth;
    let startingOffset = (width - Globals.HBESectionWidth - blockInsertOffset) / 2; //Offset to center structure around origin
    let wallYPosition = getLengthByAxis(wallMesh.geometry.boundingBox, "y") / 2; //y-Position of element (Lower edge on y = 0)
    let originalGeometry = storeBufferGeometry(wallMesh);
    let originalVolume = toFixedFloat(getVolume(wallMesh.geometry), 7);
    let elementWidth = Globals.HBESectionWidth;
    //Wenn letztes Element kleiner als Federlänge kein neues Element anfangen, sondern Elementzahl reduzieren und Feder zum Teilschneiden
    //TODO abklären
    let lastElementWidth = width - ((count - 1) * Globals.HBESectionWidth);
    if (lastElementWidth < wallMeshKeyWidth) {
        count--;
    }

    for (let i = 0; i < count; i++) {
        let block = wallMesh.clone(true); //Clone Mesh
        block.material = material;
        let xPosition = (Globals.HBESectionWidth * i) - startingOffset; //Calculate x position of current element
        let isLastElement = i === count - 1;
        if (isLastElement) {
            elementWidth = width - ((count - 1) * Globals.HBESectionWidth);
            block = cutMeshToSize(block, "x", elementWidth);
            let widthDifference = Globals.HBESectionWidth - getLengthByAxis(block.geometry.boundingBox, "x");
            xPosition -= (widthDifference + blockInsertOffset) / 2; //Calculate x position of cut element

            if (Globals.isDebug) {
                if (toFixedFloat(elementWidth) !== Globals.HBESmallElementWidth && toFixedFloat(elementWidth) !== Globals.HBESectionWidth) {
                    block.material = cutWallMaterial;
                }
            }
        }

        block.position.set(xPosition, wallYPosition, 0);//Position mesh

        //Create userData
        block.userData = {...userData};
        block.userData.isFirstElement = i === 0;
        block.userData.isLastElement = isLastElement;
        block.userData.originalGeometry = !isLastElement ? originalGeometry : storeBufferGeometry(block);
        block.userData.originalVolume = originalVolume;
        block.userData.sizedVolume = toFixedFloat(getVolume(block.geometry), 7);
        block.userData.wallElementHeight = wallElementHeight;
        block.name = "wallMesh" + pad(i, 3);

        addWallElementBoundingBox(block, elementWidth, wallElementHeight, isLastElement, i);
        addEdgeGeometry(block);
        wallGroup.addWithUuid(block);//Add all wall segments to a wall group
    }

    setObjectLayer(wallGroup, layer, true);

    if (addRaehmAndSchwelle) {
        createRaehmAndSchwelle(wallGroup, width, wallElementHeight, raehmHeight, schwelleHeight);
        wallGroup.userData.height = depth;
        wallGroup.userData.length = width;
    }

    createGroup(nameConstants.cutOutsGroupName, wallGroup);
    if (placeWall) {
        buildingGroup.addWithUuid(wallGroup); //Add group to scene
    }

    wallGroup.position.set(wallGroup.position.x, wallGroup.position.y + Globals.defaultSchwelleHeight, wallGroup.position.z);

    //Aufräumen von ggf. erzeugten leeren Elementen durch Rundungsfehler
    for (let i = 0; i < wallGroup.children.length; i++) {
        let child = wallGroup.children[i];
        let pos = child.position;
        if (isNaN(pos.x) || isNaN(pos.y) || isNaN(pos.z)) {
            child.removeFromParent();
            continue;
        }

        if (!Number.isFinite(pos.x) || !Number.isFinite(pos.y) || !Number.isFinite(pos.z)) {
            child.removeFromParent();
            continue;
        }

        if (child.type !== "Group") {
            let bounds = new Box3().setFromObject(child);
            let min = bounds.min;
            let max = bounds.max;
            if (!Number.isFinite(min.x) || !Number.isFinite(min.y) || !Number.isFinite(min.z) || !Number.isFinite(max.x) || !Number.isFinite(max.y) || !Number.isFinite(max.z) ||
                isNaN(min.x) || isNaN(min.y) || isNaN(min.z) || isNaN(max.x) || isNaN(max.y) || isNaN(max.z)) {
                child.removeFromParent();
            }
        }
    }

    if (direction !== null) {
        wallGroup.userData.direction = direction;
    }

    return wallGroup;
}

export function createExtendedWallSegment(width, depths, wallMesh, layer) {
    let wallSegments = [];

    let totalDepth = 0;
    for (let i = 0; i < depths.length; i++) {
        let wallSegment = createWallSegment(width, depths[i], wallMesh, layer, false);
        wallSegments.push(wallSegment);
        totalDepth += depths[i];
    }

    let depthPerSide = totalDepth / 2;
    /*Combine single wall segments*/
    let currentDepthPosition = -depthPerSide;
    for (let i = 0; i < wallSegments.length; i++) {
        let wallSegment = wallSegments[i];
        let bounds = new Box3().setFromObject(wallSegment);
        let minZ = bounds.min.z;
        let zDiff = currentDepthPosition - minZ;

        for (let j = wallSegment.children.length - 1; j >= 0; j--) {
            let child = wallSegment.children[j];
            if (child.name.startsWith(nameConstants.cutOutsGroupName)) {
                clearGroup(child);
                child.removeFromParent();
                continue;
            }

            clearGroup(child);
            child.translateZ(zDiff);
        }

        bounds = new Box3().setFromObject(wallSegment);
        currentDepthPosition = bounds.max.z;
    }

    let combinedWallSegment = wallSegments[0];
    for (let i = 1; i < wallSegments.length; i++) {
        let wallSegment = wallSegments[i];
        for (let j = wallSegment.children.length - 1; j >= 0; j--) {
            let child = wallSegment.children[j];
            child.name = child.name + j;
            combinedWallSegment.addWithUuid(child);
        }

        clearGroup(wallSegment);
        wallSegment.removeFromParent();
    }

    return combinedWallSegment;
}

/**
 * Überschreibt eine bestehende Wand und rückt dabei Elemente so auf dass nach einem relevanten Durchbruch immer mit einem neuen Element begonnen wird.
 * Wird bei der Erstellung von Innentüren genutzt. Alle weiteren Öffnungen liegen aktuell immer im Raster und haben dadurch keinen Einfluss.
 * Weitere Öffnungen in einer Wand können hierdurch entfernt werden, wenn kein gültiger Platz gefunden wird für diese.
 * @param existingWall - Zu überschreibende Wand
 * @param width - Breite der existierenden Wand
 * @param depth - Höhe der Wand
 * @param wallMesh - Verwendeter wallMesh zur Erstellung der neuen Wand
 * @param layer
 * @param addRaehmAndSchwelle
 * @param cutToSize
 * @param direction
 * @param isOuterWall
 * @returns {Group|null}
 */
export function createWallSegmentWithCutOuts(existingWall, width, depth, wallMesh, layer, addRaehmAndSchwelle = true, cutToSize = true, direction = null, isOuterWall = false) {
    width = toFixedFloat(width, 5);
    depth = toFixedFloat(depth, 5);
    if (width === 0 || depth === 0) {
        return null;
    }

    //Get needed data
    let material = isOuterWall ? outerWallMaterial : wallMaterial;
    //TODO: Irgendwo kommt ein offset von -0.01 in Y raus
    let raehmHeight = Globals.defaultRaehmHeight; //Höhe für Berechnungen. Kann angepasst werden, wenn dynamische Höhe nötig
    let schwelleHeight = Globals.defaultSchwelleHeight; //Höhe für Berechnungen. Kann angepasst werden, wenn dynamische Höhe nötig
    let userData = {...existingWall.userData}; //Gets userData without reference to wallMesh
    let wallGroup = new Group();
    let wallElementHeight = addRaehmAndSchwelle ? depth - schwelleHeight - raehmHeight : depth;
    let cutoutsGroup = findChildByName(existingWall, nameConstants.cutOutsGroupName);
    let existingOrientation = getWallOrientation(existingWall);
    let existingCutouts = getExistingCutoutsFromWall(width, existingOrientation, cutoutsGroup);
    let wallYPosition = getLengthByAxis(wallMesh.geometry.boundingBox, "y") / 2; //y-Position of element (Lower edge on y = 0)
    if (cutToSize) {
        wallMesh = cutMeshToSize(wallMesh, "z", wallElementHeight);
    }

    let originalGeometry = storeBufferGeometry(wallMesh);
    let originalVolume = toFixedFloat(getVolume(wallMesh.geometry), 7);

    let blockInsertOffset = getLengthByAxis(wallMesh.geometry.boundingBox, "x") - Globals.HBESectionWidth;
    let startingOffset = (width - Globals.HBESectionWidth - blockInsertOffset) / 2; //Offset to center structure around origin

    //Berechnen und Erstellen der Wandstücke
    let calculatedWidth = calculateElementWidths(width, existingCutouts);

    for (let j = 0; j < calculatedWidth.length; j++) {
        let elementWidth = calculatedWidth[j].width;
        let currentStart = calculatedWidth[j].start;

        if (!calculatedWidth[j].cutOutFiller) {

            let block = wallMesh.clone(true); //Clone Mesh
            block.material = material;
            let xPosition = currentStart - startingOffset; //Calculate x position of current element
            let isLastElement = j === calculatedWidth.length - 1;

            if (elementWidth !== Globals.HBESectionWidth || isLastElement) {
                if (calculatedWidth[j].cutAtStart) {
                    elementWidth += wallMeshKeyWidth;
                }
                block = cutMeshToSize(block, calculatedWidth[j].cutAtStart ? "-x" : "x", elementWidth);
                let widthDifference = Globals.HBESectionWidth - getLengthByAxis(block.geometry.boundingBox, "x");
                xPosition -= (widthDifference + blockInsertOffset) / 2; //Calculate x position of cut element

                if (Globals.isDebug) {
                    if (toFixedFloat(elementWidth) !== Globals.HBESmallElementWidth && toFixedFloat(elementWidth) !== Globals.HBESectionWidth) {
                        block.material = cutWallMaterial;
                    }
                }
            }

            block.position.set(xPosition, wallYPosition, 0);//Position mesh

            //Create userData
            block.userData = {...userData};
            block.userData.isFirstElement = j === 0;
            block.userData.isLastElement = isLastElement;
            block.userData.originalGeometry = !isLastElement ? originalGeometry : storeBufferGeometry(block);
            block.userData.originalVolume = originalVolume;
            block.userData.sizedVolume = toFixedFloat(getVolume(block.geometry), 7);
            block.userData.wallElementHeight = wallElementHeight;
            block.name = "wallMesh" + pad(j, 3);

            addWallElementBoundingBox(block, elementWidth, wallElementHeight, isLastElement, j);
            addEdgeGeometry(block);
            wallGroup.addWithUuid(block);//Add all wall segments to a wall group
        } else {
            //TODO: Besser Lösung finden
            /**
             * Um Innentüren besser verschieben zu können brauchen wir ein Element welches Intersected werden kann.
             * Hier wird das Intersectobjekt erzeugt. Dieses verhält sich wie ein reguläres Wandelement.
             * Muss für Preise etc. später rausgerechnet werden
             */
            let xPosition = currentStart - ((width - elementWidth) / 2);
            let fillerGeometry = new BoxGeometry(elementWidth, HBEWallDefaultThickness, 0.002);
            let fillerMesh = new Mesh(fillerGeometry, wallMaterial);
            fillerMesh.position.set(xPosition, 0.05, -wallElementHeight / 2 + 0.001);//Position mesh
            fillerMesh.userData.isFirstElement = j === 0;
            fillerMesh.userData.isLastElement = false;
            fillerMesh.userData.originalGeometry = null;
            fillerMesh.userData.originalVolume = 0;
            fillerMesh.userData.sizedVolume = 0;
            fillerMesh.userData.wallElementHeight = 0.002;
            fillerMesh.name = "wallMesh" + pad(j, 3);
            addWallElementBoundingBox(fillerMesh, elementWidth, 0.002, false, j);
            wallGroup.addWithUuid(fillerMesh);//Add all wall segments to a wall group
        }
    }

    setObjectLayer(wallGroup, layer, true);

    if (addRaehmAndSchwelle) {
        createRaehmAndSchwelle(wallGroup, width, wallElementHeight, raehmHeight, schwelleHeight);
        wallGroup.userData.height = depth;
        wallGroup.userData.length = width;
    }

    //Aufräumen von ggf. erzeugten leeren Elementen durch Rundungsfehler
    for (let i = 0; i < wallGroup.children.length; i++) {
        let child = wallGroup.children[i];
        let pos = child.position;
        if (isNaN(pos.x) || isNaN(pos.y) || isNaN(pos.z)) {
            child.removeFromParent();
            continue;
        }

        if (!Number.isFinite(pos.x) || !Number.isFinite(pos.y) || !Number.isFinite(pos.z)) {
            child.removeFromParent();
            continue;
        }

        let bounds = new Box3().setFromObject(child);
        let min = bounds.min;
        let max = bounds.max;
        if (!Number.isFinite(min.x) || !Number.isFinite(min.y) || !Number.isFinite(min.z) || !Number.isFinite(max.x) || !Number.isFinite(max.y) || !Number.isFinite(max.z) ||
            isNaN(min.x) || isNaN(min.y) || isNaN(min.z) || isNaN(max.x) || isNaN(max.y) || isNaN(max.z)) {
            child.removeFromParent();
        }
    }

    if (direction !== null) {
        wallGroup.userData.direction = direction;
    }

    wallGroup.userData.isOuterWall = isOuterWall;
    if (existingWall.userData.roof !== undefined) {
        wallGroup.userData.roof = existingWall.userData.roof;
    }

    wallGroup.position.copy(existingWall.position);
    wallGroup.rotation.copy(existingWall.rotation);
    let cutoutgroup = findChildByName(existingWall, cutOutsGroupName);
    wallGroup.addWithUuid(cutoutgroup);
    cutoutgroup = findChildByName(wallGroup, cutOutsGroupName);
    wallGroup.name = nameConstants.wallGroupName;
    buildingGroup.addWithUuid(wallGroup);
    for (let i = 0; i < cutoutgroup.children.length; i++) {
        let cutout = cutoutgroup.children[i];
        let controlobject = findChildByName(cutout, controlObjectName);
        controlobject.userData.originalParent = cutout.uuid;
    }

    //Reposition existing cutouts
    let changedCutouts = false;
    let fullElements = calculatedWidth.filter(x => x.width === HBESectionWidth);

    for (let i = 0; i < existingCutouts.snapped.length; i++) {
        let elements = [];
        let cutOut = existingCutouts.snapped[i];

        let start = cutOut.span.start;
        let elementsToCut = [];
        let firstElement = true;
        for (let j = 0; j < fullElements.length; j++) {
            let range = fullElements[j];

            if (areOverlapping(cutOut.span, range)) {
                elementsToCut.push(wallGroup.children[calculatedWidth.indexOf(range)]);

                if (firstElement) {
                    let diff = range.start - start;
                    if (j < fullElements.length - 1) {
                        let range2 = fullElements[j + 1];
                        let diff2 = range2.start - start;
                        if (diff2 < diff) {
                            diff = diff2;
                        }
                    }

                    if (toFixedFloat(Math.abs(diff)) > 0) {
                        changedCutouts = true;
                    }

                    let group = cutOut.controlObject.parent;
                    for (let k = 0; k < group.children.length; k++) {
                        group.children[k].position.x += diff;
                    }

                    let scenePosition = cutOut.controlObject.userData.sceneMatrix.position;
                    let groupPosition = cutOut.controlObject.userData.groupMatrix.position;
                    cutOut.controlObject.userData.sceneMatrix.position = new Vector3(scenePosition.x + diff, scenePosition.y, scenePosition.z);
                    cutOut.controlObject.userData.groupMatrix.position = new Vector3(groupPosition.x + diff, groupPosition.y, groupPosition.z);
                    firstElement = false;
                }
            }
        }

        if (elementsToCut.length > 0 && elementsToCut[0] !== 0) {
            elementsToCut.push(wallGroup.children[wallGroup.children.indexOf(elementsToCut[0]) - 1]);
        }

        CutOut.restoreCutOut(wallGroup, cutOut.cutOutObject, elementsToCut);

        for (let j = 0; j < elementsToCut.length; j++) {
            let child = elementsToCut[j];
            if (!child?.geometry) {
                continue;
            }
            let volume = getVolume(child.geometry);
            child.userData.originalVolume = volume;
            child.userData.sizedVolume = volume;
        }
    }

    if (existingCutouts.snapped.length > 0) {
        for (let i = 0; i < wallGroup.children.length; i++) {
            let child = wallGroup.children[i];
            if (child.type !== "Mesh" || !child.name.includes(nameConstants.wallMeshName)) {
                continue;
            }
            let volume = toFixedFloat(getVolume(child.geometry), 7);
            child.userData.originalVolume = volume;
            child.userData.sizedVolume = volume;
        }
    }

    //Calculate sized volumes
    for (let i = 0; i < wallGroup.children.length; i++) {
        let child = wallGroup.children[i];

        if (child.type !== "Mesh") {
            continue;
        }

        let sizedVolume = toFixedFloat(getVolume(child.geometry), 7);
        child.userData.sizedVolume = sizedVolume;
    }

    if (changedCutouts) {
        showMessage(t("openings_repositioned"), "Hinweis");
    }

    return wallGroup;
}

function getExistingCutoutsFromWall(width, existingOrientation, cutoutsGroup) {
    let existingCutouts = {
        nonSnapped: [],
        snapped: []
    };
    if (cutoutsGroup === null) {
        return existingCutouts;
    }

    for (let i = cutoutsGroup.children.length - 1; i >= 0; i--) {
        let cutOut = cutoutsGroup.children[i];
        let controlObject = findChildByName(cutOut, nameConstants.controlObjectName);
        if (controlObject === null) {
            clearGroup(cutOut);
            cutOut.removeFromParent();
            continue;
        }
        let userData = controlObject.userData;
        let type = getCutOutTypeFromString(userData.type);

        //Get start and end position relativ to wall start = 0;
        let preWorldPosition = controlObject.getWorldPosition(new Vector3());
        let controlObjectWidth = userData.width;
        let position = controlObject.position;
        let offset = width / 2;
        let span = {start: null, finish: null, center: null};
        let center = position.x + offset;
        span.start = toFixedFloat(center - (controlObjectWidth / 2));
        span.finish = toFixedFloat(center + (controlObjectWidth / 2));
        span.center = toFixedFloat(center);

        if (type === cutOutTypes.interiorDoor) {
            existingCutouts.nonSnapped.push(
                {cutOutObject: cutOut, controlObject: controlObject, type: type, span: span}
            );
        } else {
            existingCutouts.snapped.push(
                {cutOutObject: cutOut, controlObject: controlObject, type: type, span: span}
            );
        }
    }

    existingCutouts.nonSnapped = sortBySubKey(existingCutouts.nonSnapped, 'span', 'start');

    return existingCutouts;
}

//Vorberechnung der Elementbreiten zum Ersetzen der Wand bei Verwendung von Innentüren
function calculateElementWidths(width, existingCutouts) {
    let currentTotalWidth = 0; //Aktuelle Position in Laufrichtung der Wand
    let wallElements = []; //Alle Elemente

    let currentSectionWallElements = []; //Alle Elemente im aktuellen Segment

    let currentCutoutIndex = 0; //Index des aktuellen Ausschnitts
    let currentExistingCutout = existingCutouts.nonSnapped.length > 0 ? existingCutouts.nonSnapped[currentCutoutIndex] : null; //Aktueller CutOut mit dem gerechnet wird

    //Loopen bis die Wand auf voller Länge gefüllt ist
    let i = 0;
    while (toFixedFloat(currentTotalWidth) < toFixedFloat(width)) {
        i++;
        if (i > 1000) {
            throw new Error(t("wall_loop_exceeded"));
        }
        let currentEnd = currentTotalWidth + HBESectionWidth > width ? width : currentTotalWidth + HBESectionWidth;
        let currentSpan = {start: currentTotalWidth, finish: currentEnd}; //Start und Endposition des aktuell einzufügenden Elements
        let elementWidth = toFixedFloat(currentSpan.finish - currentSpan.start);
        let cutOutOffset = 0; //Offset für die nächste Startposition falls ein CutOut diesen verschiebt

        //Wenn kein Cutout gefunden wurde kann diese Berechnung übersprungen werden: Wand wird dann regulär von links nach rechts mit vollen Element gefüllt
        if (currentExistingCutout !== null) {
            if (areOverlapping(currentSpan, currentExistingCutout.span)) {
                if (currentSpan.finish > currentExistingCutout.span.start) {
                    currentSpan.finish = currentExistingCutout.span.start;
                    cutOutOffset = currentExistingCutout.controlObject.userData.width;
                }

                //Element ist zu klein. > Aufrücken der vorherigen Elemente
                if (currentSpan.finish - currentSpan.start < interiorDoorConstants.startEndMargin) {
                    //Differenz des letzten Elements zur Mindestgröße
                    let diff = interiorDoorConstants.startEndMargin - (currentSpan.finish - currentSpan.start);
                    //Erstes Element entsprechend aufrücken
                    if (currentSectionWallElements.length > 0) {
                        currentSectionWallElements[0].width -= diff;
                        currentSectionWallElements[0].finish -= diff;
                        currentSectionWallElements[0].cutAtStart = true;
                    }
                    //Alle weiteren Elemente verschieben
                    for (let i = 1; i < currentSectionWallElements.length; i++) {
                        currentSectionWallElements[i].start -= diff;
                        currentSectionWallElements[i].finish -= diff;
                    }
                    //Aktuelles Element anpassen, einfügen und section abschließen
                    currentSpan.start -= diff;
                    elementWidth = toFixedFloat(currentSpan.finish - currentSpan.start);
                    currentSectionWallElements.push({
                        width: elementWidth,
                        start: currentSpan.start,
                        finish: currentSpan.finish,
                        cutAtStart: false,
                        cutOutFiller: false
                    });
                    elementWidth -= diff; //Wieder rausrechnen für nächste startpunkt berechnung
                } else {
                    elementWidth = toFixedFloat(currentSpan.finish - currentSpan.start);

                    currentSectionWallElements.push({
                        width: elementWidth,
                        start: currentSpan.start,
                        finish: currentSpan.finish,
                        cutAtStart: false,
                        cutOutFiller: false
                    });
                }

                if (cutOutOffset > 0) {
                    currentSectionWallElements.push({
                        width: cutOutOffset,
                        start: currentExistingCutout.span.start,
                        finish: currentExistingCutout.span.finish,
                        cutAtStart: false,
                        cutOutFiller: true
                    });
                }

                //Save next cutout for following iterations
                currentCutoutIndex++;
                if (existingCutouts.nonSnapped.length > currentCutoutIndex) {
                    currentExistingCutout = existingCutouts.nonSnapped[currentCutoutIndex];
                } else {
                    currentExistingCutout = null;
                }

                //Reset current segment
                wallElements = wallElements.concat(currentSectionWallElements);
                currentSectionWallElements = [];
            } else {
                currentSectionWallElements.push({
                    width: elementWidth,
                    start: currentSpan.start,
                    finish: currentSpan.finish,
                    cutAtStart: false,
                    cutOutFiller: false
                });
            }
        } else {
            //Füge das aktuelle Element in die aktuelle section
            currentSectionWallElements.push({
                width: elementWidth,
                start: currentSpan.start,
                finish: currentSpan.finish,
                cutAtStart: false,
                cutOutFiller: false
            });
        }

        currentTotalWidth = toFixedFloat(currentTotalWidth + elementWidth + cutOutOffset);
    }

    wallElements = wallElements.concat(currentSectionWallElements); //add last section to wallElements

    for (let i = 0; i < wallElements.length; i++) {
        wallElements[i].start = toFixedFloat(wallElements[i].start);
        wallElements[i].finish = toFixedFloat(wallElements[i].finish);
        wallElements[i].width = toFixedFloat(wallElements[i].width);
    }

    return wallElements;
}

//Rähm und Schwelle für ein Wandstück erstellen
function createRaehmAndSchwelle(wallGroup, width, wallElementHeight, raehmHeight, schwelleHeight) {
    let halfWallThickness = Globals.HBEWallDefaultThickness / 2;

    //Rähm erstellen
    let raehmPosition = new Vector3(wallGroup.position.x, wallGroup.position.y + halfWallThickness, -wallElementHeight / 2 - raehmHeight / 2);
    let raehm = new Raehm(width, raehmHeight, Globals.defaultRaehmWidth, raehmPosition);
    wallGroup.addWithUuid(raehm);

    //Schwelle erstellen
    let schewellePosition = new Vector3(wallGroup.position.x, wallGroup.position.y + halfWallThickness, wallElementHeight / 2 + schwelleHeight / 2);
    let schwelle = new Schwelle(width, schwelleHeight, Globals.defaultSchwelleWidth, schewellePosition);
    wallGroup.addWithUuid(schwelle);
}

export function addWallElementBoundingBox(block, elementWidth, wallElementHeight, isLastElement, index) {
    //Add a bounding box
    let box = new Mesh(new BoxGeometry(elementWidth, wallElementHeight, Globals.HBEWallDefaultThickness), boundingBoxMaterial);
    box.visible = false;
    box.name = nameConstants.wallMeshBBoxName + pad(index, 3);
    box.rotateX(Math.PI / 2);
    if (!isLastElement) {
        box.translateX(-0.5 * wallMeshKeyWidth);
    }
    block.addWithUuid(box);
}

export function restoreWallLayers(wallElements) {
    if (wallElements.children !== undefined) {
        wallElements = wallElements.children;
    }

    for (let i = 0; i < wallElements.length; i++) {
        let child = wallElements[i];

        //Restore layers
        if (child.name.includes("raehmMesh")) {
            setObjectLayer(child, Globals.layers.raehm, true);
        } else if (child.name.includes("schwelleMesh")) {
            setObjectLayer(child, Globals.layers.schwelle, true);
        } else {
            setObjectLayer(child, Globals.layers.wall, true);
        }
    }
}

//Cleanup
export function deleteWall(wall) {
    SceneManager.clearGroup(wall);
    wall.removeFromParent();
    createRooms();
}

export function getIntersectingWalls(wallGroup, wallGroups = null, onlyIntersectAtEndPoints = false, extendBoundingBox = false, checkOverlapInBothDirections = false, intersectingSupportBeam = false, checkOverlapByOrientation = false) {
    //Check for bounding box collisions
    let walls = [];
    if (wallGroups === null) {
        wallGroups = findChildrenByName(buildingGroup, nameConstants.wallGroupName, false, true, 2);
    }

    let wallGroupBBox = new Box3().setFromObject(wallGroup);
    let offset = new Vector3(0, 0, 0);
    if (extendBoundingBox) {
        let orientation = getWallOrientation(wallGroup);
        if (wallGroup.name === supportBeamMeshName) {
            let length = wallGroup.userData.width;
            let size = wallGroupBBox.getSize(new Vector3());
            orientation = toFixedFloat(length) === toFixedFloat(size.x) ? "x" : "z";
        }

        if (orientation === "x") {
            offset.x = 0.1;
        } else {
            offset.z = 0.1;
        }
    }

    let wallGroupStartEndBoxes = getStartAndEndPointBoundingBox(wallGroup, offset);
    for (let i = 0; i < wallGroups.length; i++) {
        let wallGroupToCheck = wallGroups[i];

        if (wallGroupToCheck === wallGroup) {
            continue; //Nicht gegen sich selbst prüfen
        }

        if (!onlyIntersectAtEndPoints) {
            //Wandintersection ausrechnen. Boxen um 0.03 erweitern, um einen Schnittpunkt sicherzustellen, wenn einer da sein müsste (Toleranz)
            let wallGroupToCheckBBox = new Box3().setFromObject(wallGroupToCheck);
            let intersect = wallGroupToCheckBBox.expandByVector(new Vector3(0.03, 0.03, 0.03)).intersect(new Box3().copy(wallGroupBBox).expandByVector(new Vector3(0.03, 0.03, 0.03)));
            let size = intersect.getSize(new Vector3());
            let xOverlap = toFixedFloat(size.x, 2);
            let zOverlap = toFixedFloat(size.z, 2);

            if (intersectingSupportBeam && wallGroupToCheck.name === supportBeamMeshName) {
                if (xOverlap >= Globals.HBEWallDefaultThickness && zOverlap >= Globals.HBEWallDefaultThickness) {
                    walls.push(wallGroupToCheck);
                }
            } else {
                //Prüfung auf Schnittgrößen: >= 0.1 Wandschnitt auf voller Breite / < 0.1 kein Schnitt
                if ((xOverlap >= Globals.HBEWallDefaultThickness && zOverlap < Globals.HBEWallDefaultThickness) || (xOverlap < Globals.HBEWallDefaultThickness && zOverlap >= Globals.HBEWallDefaultThickness)) {
                    walls.push(wallGroupToCheck);
                } else if (checkOverlapInBothDirections && xOverlap >= Globals.HBEWallDefaultThickness && zOverlap >= Globals.HBEWallDefaultThickness) {
                    walls.push(wallGroupToCheck);
                }
            }
        } else {
            let wallGroupToCheckBoxes = getStartAndEndPointBoundingBox(wallGroupToCheck);

            for (let j = 0; j < wallGroupStartEndBoxes.length; j++) {
                for (let k = 0; k < wallGroupToCheckBoxes.length; k++) {
                    let wallGroupBox = new Box3().copy(wallGroupStartEndBoxes[j]).expandByVector(new Vector3(0.03, 0.03, 0.03));
                    let currentWallToCheckBox = new Box3().copy(wallGroupToCheckBoxes[k]).expandByVector(new Vector3(0.03, 0.03, 0.03));
                    let intersect = currentWallToCheckBox.intersect(wallGroupBox);
                    let size = intersect.getSize(new Vector3());
                    let xOverlap = toFixedFloat(size.x, 2);
                    let zOverlap = toFixedFloat(size.z, 2);

                    //Prüfung auf Schnittgrößen: >= 0.1 Wandschnitt auf voller Breite / < 0.1 kein Schnitt
                    if ((xOverlap >= Globals.HBEWallDefaultThickness && zOverlap < Globals.HBEWallDefaultThickness) || 
                        (xOverlap < Globals.HBEWallDefaultThickness && zOverlap >= Globals.HBEWallDefaultThickness) ||
                        (xOverlap >= Globals.HBEWallDefaultThickness && zOverlap >= Globals.HBEWallDefaultThickness)
                        ) {
                        if (checkOverlapByOrientation) {
                            //Sonderfall für Raumerkennung.
                            //Wenn der Unterzug neben der Wand liegt schneiden diese sich eventuell trotzdem erweitern sich aber nicht direkt.
                            /*
                             * ||           ||
                             * ||||         ||
                             *   || statt   || das darf keine Erweiterung sein
                             */

                            let orientation1 = getWallOrientation(wallGroup);
                            let orientation2 = getWallOrientation(wallGroupToCheck);

                            //Wände müssen gleich gerichtet sein
                            if (orientation1 === orientation2) {
                                //Wände müssen ein overlap an der Seite haben in der sie sich bei einem gültigen Fall schneiden würden
                                if (orientation1 === "x" && zOverlap >= Globals.HBEWallDefaultThickness) {
                                    walls.push(wallGroupToCheck);
                                } else if (orientation1 === "z" && xOverlap >= Globals.HBEWallDefaultThickness) {
                                    walls.push(wallGroupToCheck);
                                }
                            }
                        } else {
                            walls.push(wallGroupToCheck);
                        }
                    } else if (wallGroupToCheck.name === supportBeamMeshName || wallGroup.name === supportBeamMeshName) {
                        if (xOverlap >= Globals.HBEWallDefaultThickness && zOverlap >= Globals.HBEWallDefaultThickness) {
                            walls.push(wallGroupToCheck);
                        }
                    }
                }
            }
        }
    }

    return walls;
}

function getStartAndEndPointBoundingBox(wall, offset = null) {
    let bounds = new Box3().setFromObject(wall);
    bounds.min.y = 0;
    bounds.max.y = 0;

    if (offset !== null) {
        bounds.min.sub(offset);
        bounds.max.add(offset);
    }

    let boundingBoxes = [];
    let minTopRight = new Vector3().copy(bounds.min).add(new Vector3(Globals.HBEWallDefaultThickness, 0, Globals.HBEWallDefaultThickness));
    boundingBoxes.push(new Box3().setFromPoints([bounds.min, minTopRight]));

    let maxBottomLeft = new Vector3().copy(bounds.max).sub(new Vector3(Globals.HBEWallDefaultThickness, 0, Globals.HBEWallDefaultThickness));
    boundingBoxes.push(new Box3().setFromPoints([bounds.max, maxBottomLeft]));

    return boundingBoxes;
}

export function cutWallWithMesh(wallElements, cutMesh, addEdgeGeom = true, removeBBox = false, checkForEmptyVolumes = false, expandCut = false) {
    /*Für Durchbrüche: Bestimmen welche Elemente komplett entfernt wurden aber Reste hinterlassen für die klickbarkeit.
    Volumen unter 0.0005 können später für die Berechnung ignorieret werden*/
    cutMesh.updateMatrix();

    if (wallElements.children !== undefined) {
        wallElements = wallElements.children;
    }

    for (let i = wallElements.length - 1; i >= 0; i--) {
        let child = wallElements[i];

        //Filtern von ungültigen Elementen
        if (!Number.isFinite(child.position.x) || !Number.isFinite(child.position.z)) {
            child.removeFromParent();
            continue;
        }

        child.updateMatrix();
        if (child.geometry === undefined) {
            continue;
        }
        let volumeBefore = getVolume(child.geometry);
        let newWallElement = CSG.subtract(child, cutMesh);
        newWallElement.geometry.computeBoundingBox();
        child.geometry.dispose();
        child.geometry = newWallElement.geometry;
        for (let i = child.children.length - 1; i >= 0; i--) {
            let subChild = child.children[i];
            if (subChild.type === "LineSegments") {
                clearGroup(subChild);
                subChild.removeFromParent();
            } else if (subChild.name.startsWith(nameConstants.wallMeshBBoxName) && removeBBox) {
                subChild.removeFromParent();
            }
        }
        let volumeAfter = getVolume(child.geometry);

        if (checkForEmptyVolumes && volumeBefore !== volumeAfter && volumeAfter < 0.0005) {
            child.userData.removedFromCutOut = true;
            child.visible = false;
        }

        if (new Box3().setFromObject(child).isEmpty()) {
            child.removeFromParent(); //Entfernen weil komplett weggeschnitten
        }

        if (addEdgeGeom) {
            addEdgeGeometry(child);
        }
    }
}

export function getWallOrientation(wall) {
    if (wall.name === supportBeamMeshName) {
        let length = wall.userData.width;
        let bounds = new Box3().setFromObject(wall);
        let size = bounds.getSize(new Vector3());
        return toFixedFloat(length) === toFixedFloat(size.x) ? "x" : "z";
    } else {
        //z-Achse, weil Wand liegend konstruiert wird und um x-Achse rotiert wird zum aufrecht stellen
        let quaternion = wall.getWorldQuaternion(new Quaternion());
        let rotation = new Euler().setFromQuaternion(quaternion).z;
        return (rotation === 0 || Math.abs(rotation) === Math.PI) ? "x" : "z";
    }
}
